<template>
  <form @submit.prevent="submitForm">
    <FormField
      id="Clave"
      label="Clave"
      type="text"
      v-model="formData.Clave"
      :required="true"
      :maxlength="50"
      :disabled="isEditing"
      helpText="Clave única del material"
    />
    
    <!-- Campo EmpresaId oculto - se captura automáticamente -->
    <input type="hidden" v-model="formData.EmpresaId" />
    
    <FormField
      id="Nombre"
      label="Nombre"
      type="text"
      v-model="formData.Nombre"
      :required="true"
      :maxlength="250"
      helpText="Nombre del material"
    />
    
    <FormField
      id="Descripcion"
      label="Descripción"
      type="textarea"
      v-model="formData.Descripcion"
      :maxlength="500"
      helpText="Descripción detallada del material"
    />
    
    <FormField
      id="ClaveErp"
      label="Clave ERP"
      type="text"
      v-model="formData.ClaveErp"
      :maxlength="50"
      helpText="Clave en el sistema ERP"
    />
    
    <FormField
      id="Umedida"
      label="Unidad de Medida"
      type="text"
      v-model="formData.Umedida"
      :maxlength="50"
      helpText="Unidad de medida del material"
    />
    
    <FormField
      id="GrupoMaterial"
      label="Grupo de Material"
      type="text"
      v-model="formData.GrupoMaterial"
      :maxlength="50"
      helpText="Grupo al que pertenece el material"
    />
    
    <FormField
      id="CuentaContable"
      label="Cuenta Contable"
      type="text"
      v-model="formData.CuentaContable"
      :maxlength="50"
      helpText="Cuenta contable principal"
    />
    
    <FormField
      id="TipoArticulo"
      label="Tipo de Artículo"
      type="select"
      v-model="formData.TipoArticulo"
      :required="true"
      :options="tipoArticuloOptions"
      helpText="Tipo de artículo"
    />
    
    <div class="row">
      <div class="col-md-4">
        <FormField
          id="EsInventariable"
          label="Es Inventariable"
          type="checkbox"
          v-model="formData.EsInventariable"
          helpText="Indica si es inventariable"
        />
      </div>
      <div class="col-md-4">
        <FormField
          id="EsDeCompra"
          label="Es de Compra"
          type="checkbox"
          v-model="formData.EsDeCompra"
          helpText="Indica si se puede comprar"
        />
      </div>
      <div class="col-md-4">
        <FormField
          id="EsDeVenta"
          label="Es de Venta"
          type="checkbox"
          v-model="formData.EsDeVenta"
          helpText="Indica si se puede vender"
        />
      </div>
    </div>
    
    <FormField
      id="EsActivo"
      label="Es Activo"
      type="checkbox"
      v-model="formData.EsActivo"
      helpText="Indica si el material está activo"
    />
    
    <div class="row">
      <div class="col-md-6">
        <FormField
          id="UltimoPrecioCompra"
          label="Último Precio de Compra"
          type="number"
          v-model="formData.UltimoPrecioCompra"
          step="0.01"
          min="0"
          helpText="Último precio de compra registrado"
        />
      </div>
      <div class="col-md-6">
        <FormField
          id="PrecioPromedio"
          label="Precio Promedio"
          type="number"
          v-model="formData.PrecioPromedio"
          step="0.01"
          min="0"
          helpText="Precio promedio del material"
        />
      </div>
    </div>
    
    <div class="row">
      <div class="col-md-4">
        <FormField
          id="PrecioUltimo"
          label="Precio Último"
          type="number"
          v-model="formData.PrecioUltimo"
          step="0.01"
          min="0"
          helpText="Último precio registrado"
        />
      </div>
      <div class="col-md-4">
        <FormField
          id="PrecioMinimo"
          label="Precio Mínimo"
          type="number"
          v-model="formData.PrecioMinimo"
          step="0.01"
          min="0"
          helpText="Precio mínimo registrado"
        />
      </div>
      <div class="col-md-4">
        <FormField
          id="PrecioMaximo"
          label="Precio Máximo"
          type="number"
          v-model="formData.PrecioMaximo"
          step="0.01"
          min="0"
          helpText="Precio máximo registrado"
        />
      </div>
    </div>
    
    <div class="row">
      <div class="col-md-4">
        <FormField
          id="Impuesto1"
          label="Impuesto 1"
          type="text"
          v-model="formData.Impuesto1"
          :maxlength="50"
          helpText="Primer impuesto aplicable"
        />
      </div>
      <div class="col-md-4">
        <FormField
          id="Impuesto2"
          label="Impuesto 2"
          type="text"
          v-model="formData.Impuesto2"
          :maxlength="50"
          helpText="Segundo impuesto aplicable"
        />
      </div>
      <div class="col-md-4">
        <FormField
          id="Impuesto3"
          label="Impuesto 3"
          type="text"
          v-model="formData.Impuesto3"
          :maxlength="50"
          helpText="Tercer impuesto aplicable"
        />
      </div>
    </div>
    
    <div class="row">
      <div class="col-md-4">
        <FormField
          id="CuentaContableCosto"
          label="Cuenta Contable Costo"
          type="text"
          v-model="formData.CuentaContableCosto"
          :maxlength="50"
          helpText="Cuenta contable para costos"
        />
      </div>
      <div class="col-md-4">
        <FormField
          id="CuentaContableVenta"
          label="Cuenta Contable Venta"
          type="text"
          v-model="formData.CuentaContableVenta"
          :maxlength="50"
          helpText="Cuenta contable para ventas"
        />
      </div>
      <div class="col-md-4">
        <FormField
          id="CuentaContableGasto"
          label="Cuenta Contable Gasto"
          type="text"
          v-model="formData.CuentaContableGasto"
          :maxlength="50"
          helpText="Cuenta contable para gastos"
        />
      </div>
    </div>
    
    <div class="d-flex gap-2 mt-4">
      <button type="button" class="btn btn-primary" :disabled="loading" @click="submitForm">
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i v-else class="bi bi-save me-1"></i>
        {{ isEditing ? 'Actualizar' : 'Guardar' }}
      </button>
      <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
        <i class="bi bi-x-circle me-1"></i> Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import FormField from '@/shared/components/FormField.vue';
import empresaMixin from '@/shared/mixins/empresaMixin';

export default {
  name: 'CatMaterialForm',
  components: {
    FormField
  },
  mixins: [empresaMixin],
  props: {
    material: {
      type: Object,
      default: () => ({
        Clave: '',
        EmpresaId: null,
        Nombre: '',
        Descripcion: '',
        ClaveErp: '',
        Umedida: '',
        GrupoMaterial: '',
        CuentaContable: '',
        TipoArticulo: '',
        EsInventariable: false,
        EsDeCompra: false,
        EsDeVenta: false,
        EsActivo: true,
        UltimoPrecioCompra: 0,
        PrecioPromedio: 0,
        PrecioUltimo: 0,
        PrecioMinimo: 0,
        PrecioMaximo: 0,
        Impuesto1: '',
        Impuesto2: '',
        Impuesto3: '',
        CuentaContableCosto: '',
        CuentaContableVenta: '',
        CuentaContableGasto: ''
      })
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: { ...this.material },
      tipoArticuloOptions: [
        { value: 'P', label: 'Producto' },
        { value: 'S', label: 'Servicio' },
        { value: 'M', label: 'Materia Prima' },
        { value: 'F', label: 'Producto Final' },
        { value: 'O', label: 'Otro' }
      ]
    };
  },
  watch: {
    material: {
      handler(newValue) {
        this.formData = { ...newValue };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    submitForm() {
      // Asegurar que la empresa esté capturada antes de enviar
      this.ensureEmpresaCaptured();
      
      // Preparar datos para envío
      const dataToSubmit = { ...this.formData };
      
      this.$emit('submit', dataToSubmit);
    }
  }
};
</script>

<style scoped>
/* Estilos específicos del formulario si son necesarios */
</style>